(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["umc-package-request"] && !Shopify.designMode) return;
  try {
    
function umcSetupPackage(root) {
  root.querySelectorAll('.umc-package-form').forEach(form => {
    if (form.dataset.packageReady) return;
    form.dataset.packageReady = 'true';
    const choice = form.querySelector('[data-package-choice]');
    const enableNativeSelects = () => form.querySelectorAll('select[tabindex="-1"]').forEach(select => select.removeAttribute('tabindex'));
    enableNativeSelects();
    new MutationObserver(enableNativeSelects).observe(form, {childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex']});
    const field = name => form.elements.namedItem('contact[' + name + ']');
    const presets = {
      'buro-s': [4, 500, 1, 1],
      'buro-m': [8, 1000, 2, 2],
      'buro-l': [12, 1500, 4, 3],
      'buro-xl': [12, 2000, 6, 4],
      'praxis-s': [4, 500, 2, 1],
      'praxis-m': [8, 1000, 4, 2],
      'praxis-l': [12, 1500, 6, 3],
      'praxis-xl': [12, 2000, 8, 4],
      'haushalt-monatspaket': [8, 500, 1, 1]
    };
    const summary = form.querySelector('[data-package-summary]');
    const selectedText = input => input.options[input.selectedIndex].text;
    const updateSummary = () => {
      summary.hidden = !choice.value;
      if (summary.hidden) return;
      const wc = field('Toilettenpapier');
      const soap = field('Handseife_ml');
      const paper = field('Papierhandtuecher_Packungen_je_250_Blatt');
      const bags = field('Muellbeutel_Rollen');
      const number = value => value === '' ? '—' : Number(value).toLocaleString(document.documentElement.lang || 'de');
      const values = {
        package: selectedText(choice),
        wc: selectedText(wc),
        soap: number(soap.value) + ' ml',
        paper: number(paper.value) + ' ' + paper.dataset.unitLabel + ' · ' + number(paper.value === '' ? '' : Number(paper.value) * 250) + ' ' + paper.dataset.sheetLabel + ' · ' + selectedText(field('Papierhandtuecher_Lagen')) + ' · ' + selectedText(field('Papierhandtuecher_Farbe')),
        bags: number(bags.value) + ' ' + bags.dataset.unitLabel + ' · ' + selectedText(field('Muellbeutel_Liter'))
      };
      Object.entries(values).forEach(([key, value]) => {
        summary.querySelector('[data-summary="' + key + '"]').textContent = value;
      });
    };
    const applyPreset = () => {
      const values = presets[choice.value];
      if (!values) { updateSummary(); return; }
      ['Toilettenpapier', 'Handseife_ml', 'Papierhandtuecher_Packungen_je_250_Blatt', 'Muellbeutel_Rollen'].forEach((name, index) => { field(name).value = values[index]; });
      field('Papierhandtuecher_Lagen').selectedIndex = 0;
      field('Papierhandtuecher_Farbe').selectedIndex = 0;
      field('Muellbeutel_Liter').value = '35';
      updateSummary();
    };
    choice.addEventListener('change', applyPreset);
    form.querySelector('[data-package-reset]').addEventListener('click', applyPreset);
    form.addEventListener('input', updateSummary);
    form.addEventListener('change', updateSummary);
    const requested = new URL(window.location.href).searchParams.get('paket');
    if (requested && presets[requested]) { choice.value = requested; applyPreset(); }
    else updateSummary();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => umcSetupPackage(document));
else umcSetupPackage(document);
document.addEventListener('shopify:section:load', event => umcSetupPackage(event.target));

  } catch(e) { console.error(e); }
})();
})();
